import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PlaylistPage from './PlaylistPage';

function MusicLayout() {
  return (
    <div>
      <Routes>
        <Route index element={<Navigate to="/music/playlist" replace />} />
        <Route path="playlist" element={<PlaylistPage />} />
      </Routes>
    </div>
  );
}

export default MusicLayout;
